export enum AgentType {
    OUTBOUND="OUTBOUND",
    INBOUND="INBOUND",
    SMS="SMS",
    ALL= "ALL"
}
